<div class="spinner-component" *ngIf="spinner.isShowing.value">
    <div class="spinner">
        
    </div>
</div>